import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router';
import { AuthProvider } from './context/AuthProvider';
import { AxiosInterceptor } from './api/AxiosInterceptor';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import './translations/i18n';
import ScrollToTop from './components/ScrollToTop';
import { registerSW } from 'virtual:pwa-register';

const SERVICE_WORKER_UPDATE_INTERVAL_MS = 60 * 60 * 1000;

registerSW({
  immediate: true,
  onRegisteredSW(_swUrl, registration) {
    if (!registration) {
      return;
    }

    const checkForServiceWorkerUpdate = () => {
      registration.update().catch(() => undefined);
    };

    window.setInterval(
      checkForServiceWorkerUpdate,
      SERVICE_WORKER_UPDATE_INTERVAL_MS
    );

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        checkForServiceWorkerUpdate();
      }
    });
  },
});

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <AxiosInterceptor>
            <App />
          </AxiosInterceptor>
        </AuthProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
